import { seo } from '../seo';
export { TermsOfServicePage as default } from '../../src/pages/Legal/TermsOfServicePage';
export const meta = () => seo('legal.terms');
